import {
  ExperimentProgramPage,
  ExperimentProgramPageDataProps,
} from '~/features/experiments/price-card-ab-test-2026/components/experiment-program-page';
import { VariantCPriceCard } from '~/features/experiments/price-card-ab-test-2026/components/variant-c-price-card';
import { getStaticPaths, getStaticProps } from '~/pages/course/[slug]';

export { getStaticPaths, getStaticProps };

export default function VariantCProgramPage(props: ExperimentProgramPageDataProps) {
  return (
    <ExperimentProgramPage
      {...props}
      paidPriceCardSlot={(slotProps) => (
        <VariantCPriceCard
          {...slotProps}
          imageUrl={props.imageUrl}
          programKey={props.staticPriceCardProps.programKey}
          programSemanticType={props.staticPriceCardProps.programSemanticType}
          programTitle={props.staticPriceCardProps.programTitle}
        />
      )}
    />
  );
}
